(function () {
  "use strict";
  var root = document.querySelector(".h2opure-lp");
  if (!root) return;

  // Keep the calculator shortcut beside the theme's account and cart controls,
  // without changing the shared header on non-landing pages.
  if (root.querySelector("#calc")) {
    document.documentElement.classList.add("lp-has-header-calc");
    function insertCalcLink() {
      var headerActions = document.querySelector("header-actions");
      if (!headerActions || headerActions.querySelector(".lp-header-calc-link")) return;
      var calcLink = document.createElement("a");
      calcLink.className = "lp-header-calc-link";
      calcLink.href = "#calc";
      calcLink.textContent = "H2O Calculator";
      headerActions.insertBefore(calcLink, headerActions.firstChild);
    }
    insertCalcLink();
    // Horizon can replace header children as its custom element initializes.
    var headerComponent = document.querySelector("header-component");
    if (headerComponent && window.MutationObserver) {
      new MutationObserver(insertCalcLink).observe(headerComponent, { childList: true, subtree: true });
    }
  }

  // Current year
  var yr = root.querySelector("#lp-year");
  if (yr) yr.textContent = new Date().getFullYear();

  // Hide theme "Join the club" newsletter section on this LP
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.textContent.indexOf('Join the club') !== -1) s.style.display = 'none';
    });
  });

  // Build 15 droplet ticks for the value-scale visual
  var gallons = root.querySelector(".lp-scale__gallons");
  if (gallons) {
    for (var d = 0; d < 15; d++) {
      var drop = document.createElement("span");
      drop.className = "lp-drop";
      gallons.appendChild(drop);
    }
  }

  // Dosage calculator. Drops use 6 mL dosing (8/gallon). Bottle counts are
  // alternatives: ceil(G/15) for 6 mL, ceil(G/2500) for 1 Liter. Not a sum.
  var DROPS_PER_GALLON = 8;
  var GALLONS_PER_BOTTLE = 15;
  var GALLONS_PER_LITER = 2500;
  var MAX_GALLONS = 100000;
  var ML_PER_GALLON = 0.4;
  var ML_PER_US_TSP = 4.93;
  var ML_PER_US_TBSP = 14.79;
  var ML_PER_US_FL_OZ = 29.57353;
  var ML_PER_US_CUP = 236.5882;
  var input = root.querySelector("#lp-gallons");
  var dropsOut = root.querySelector("#lp-drops");
  var bottlesOut = root.querySelector("#lp-bottles");
  var bottlesLbl = root.querySelector("#lp-bottles-lbl");
  var litersOut = root.querySelector("#lp-liters");
  var litersLbl = root.querySelector("#lp-liters-lbl");
  var literNote = root.querySelector("#lp-calc-liter-note");
  var mlOut = root.querySelector("#lp-measure-ml");
  var tspOut = root.querySelector("#lp-measure-tsp");
  var tbspOut = root.querySelector("#lp-measure-tbsp");
  var flOzOut = root.querySelector("#lp-measure-fl-oz");
  var cupsOut = root.querySelector("#lp-measure-cups");

  function fmt(n) { return n.toLocaleString("en-US"); }

  function fmtApprox(n) {
    if (n > 0 && n < 0.005) return "< 0.01";
    return "≈ " + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function setCount(el, labelEl, n, singular, plural) {
    if (el) el.textContent = fmt(n);
    if (labelEl) labelEl.textContent = n === 1 ? singular : plural;
  }

  function recalc() {
    if (!input) return;
    var g = Number(input.value);
    if (input.value.trim() === "" || !Number.isFinite(g) || !Number.isInteger(g) || g < 1 || g > MAX_GALLONS) {
      [dropsOut, bottlesOut, litersOut, mlOut, tspOut, tbspOut, flOzOut, cupsOut].forEach(function (el) {
        if (el) el.textContent = "—";
      });
      if (literNote) literNote.hidden = true;
      return;
    }
    var drops = g * DROPS_PER_GALLON;
    var bottles = Math.ceil(g / GALLONS_PER_BOTTLE);
    var liters = Math.ceil(g / GALLONS_PER_LITER);
    if (dropsOut) dropsOut.textContent = fmt(drops);
    setCount(bottlesOut, bottlesLbl, bottles, "6 mL bottle", "6 mL bottles");
    setCount(litersOut, litersLbl, liters, "1 Liter bottle", "1 Liter bottles");
    if (literNote) literNote.hidden = g >= GALLONS_PER_LITER;
    var ml = g * ML_PER_GALLON;
    if (mlOut) mlOut.textContent = ml.toLocaleString("en-US", { maximumFractionDigits: 1 });
    if (tspOut) tspOut.textContent = fmtApprox(ml / ML_PER_US_TSP);
    if (tbspOut) tbspOut.textContent = fmtApprox(ml / ML_PER_US_TBSP);
    if (flOzOut) flOzOut.textContent = fmtApprox(ml / ML_PER_US_FL_OZ);
    if (cupsOut) cupsOut.textContent = fmtApprox(ml / ML_PER_US_CUP);
  }

  if (input) {
    input.addEventListener("input", recalc);
    input.addEventListener("change", function () {
      var g = Number(input.value);
      if (input.value.trim() === "" || !Number.isFinite(g) || g < 1) input.value = 1;
      else if (g > MAX_GALLONS) input.value = MAX_GALLONS;
      recalc();
    });
  }

  root.querySelectorAll(".lp-calc__input button[data-step]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!input) return;
      var step = Number(btn.getAttribute("data-step")) || 0;
      var g = Number(input.value);
      if (input.value.trim() === "" || !Number.isFinite(g) || !Number.isInteger(g) || g < 1) g = 0;
      g += step;
      if (g < 1) g = 1;
      if (g > MAX_GALLONS) g = MAX_GALLONS;
      input.value = g;
      recalc();
    });
  });

  recalc();

  // Smooth scroll — all LP anchor links
  root.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var id = link.getAttribute('href');
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Direct to checkout — intercept buy form submit
  var buyForm = root.querySelector('#lp-buy-form');
  if (buyForm) {
    buyForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = buyForm.querySelector('[name="add"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var formData = new FormData(buyForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function() { window.location.href = '/checkout'; })
        .catch(function() { window.location.href = '/checkout'; });
    });
  }

  // 1L form — separate from bundle form so tier qty/price JS cannot intercept it
  var literForm = root.querySelector('#lp-liter-buy-form');
  if (literForm) {
    var literPending = false;
    var literBtnDefault = '';
    var literError = literForm.querySelector('#lp-liter-form-error');
    if (!literError) {
      literError = document.createElement('p');
      literError.setAttribute('id', 'lp-liter-form-error');
      literError.setAttribute('role', 'alert');
      literError.setAttribute('aria-live', 'polite');
      literError.className = 'lp-liter__note';
      literError.hidden = true;
      literForm.appendChild(literError);
    }
    function showLiterError(msg) {
      literError.textContent = msg;
      literError.hidden = false;
    }
    function clearLiterError() {
      literError.textContent = '';
      literError.hidden = true;
    }
    function restoreLiterButton(btn) {
      if (!btn) return;
      btn.disabled = false;
      btn.textContent = literBtnDefault || 'Add to Cart';
    }
    literForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (literPending) return;
      var btn = literForm.querySelector('[name="add"]');
      literPending = true;
      clearLiterError();
      if (btn) {
        literBtnDefault = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }
      var formData = new FormData(literForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(resp) {
          if (!resp.ok) {
            var msg = (resp.status === 429)
              ? 'Too many requests. Please wait a moment and try again.'
              : (resp.status === 422)
                ? 'Could not add this bottle to your cart. Please try again.'
                : 'Could not add this bottle to your cart. Please try again.';
            showLiterError(msg);
            restoreLiterButton(btn);
            literPending = false;
            return;
          }
          window.location.href = '/checkout';
        })
        .catch(function() {
          showLiterError('Network error. Check your connection and try again.');
          restoreLiterButton(btn);
          literPending = false;
        });
    });
  }

  // Sticky buy bar — appears after hero scrolls out
  var stickyBar = root.querySelector('#lp-sticky');
  var heroSection = root.querySelector('.lp-hero');
  if (stickyBar && heroSection) {
    function updateSticky() {
      var heroBottom = heroSection.getBoundingClientRect().bottom;
      if (heroBottom < 0) {
        stickyBar.classList.add('is-visible');
        stickyBar.removeAttribute('aria-hidden');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
  }

  // Bundle tier selector
  var tierLabels = root.querySelectorAll('.lp-tier');
  var tierQtyInput = root.querySelector('#lp-tier-qty');
  var tierPriceEl = root.querySelector('#lp-tier-price');
  var stickyPriceEl = root.querySelector('#lp-sticky-price');

  function applyTier(label) {
    var qty = parseInt(label.getAttribute('data-qty'), 10) || 1;
    var price = label.getAttribute('data-price') || '';
    if (tierQtyInput) tierQtyInput.value = qty;
    if (tierPriceEl) tierPriceEl.textContent = price;
    if (stickyPriceEl) stickyPriceEl.textContent = price;
  }

  tierLabels.forEach(function(label) {
    label.addEventListener('click', function() { applyTier(label); });
    var radio = label.querySelector('input[type=radio]');
    if (radio && radio.checked) applyTier(label);
  });

  // Header logo → white when scrolled over dark sections
  (function() {
    var darkSels = [
      '.lp-uses', '.lp-compare', '.lp-offer',
      '.lp-guarantee', '.lp-final', '.lp-footer'
    ];
    var darkEls = darkSels.map(function(s) { return document.querySelector(s); }).filter(Boolean);
    var siteHeader = document.querySelector('.header-wrapper, .shopify-section-header, header[class*="header"]');
    if (!siteHeader || !darkEls.length) return;

    var headerH = siteHeader.offsetHeight || 72;

    function updateHeaderColor() {
      var overDark = darkEls.some(function(el) {
        var r = el.getBoundingClientRect();
        return r.top <= headerH && r.bottom > headerH / 2;
      });
      document.documentElement.classList.toggle('lp-header-over-dark', overDark);
    }

    window.addEventListener('scroll', updateHeaderColor, { passive: true });
    updateHeaderColor();
  })();
})();

/* ============================================================
   Delightful animations & micro-interactions
   ============================================================ */
(function () {
  "use strict";
  var root = document.querySelector(".h2opure-lp");
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // 1) Tag scroll-reveal targets
  var revealSelectors = [
    ".lp-section-head", ".lp-benefit", ".lp-step", ".lp-proof__copy",
    ".lp-proof__card", ".lp-uses__hd", ".lp-compare__wrap",
    ".lp-value__media", ".lp-value__copy", ".lp-review", ".lp-tier",
    ".lp-guarantee__stamp", ".lp-guarantee__copy", ".lp-accordion details",
    ".lp-calc", ".lp-miracle__copy", ".lp-trust-bar", ".lp-final h2",
    ".lp-final p", ".lp-final .lp-btn"
  ];
  revealSelectors.forEach(function (sel) {
    root.querySelectorAll(sel).forEach(function (el) { el.classList.add("lp-reveal"); });
  });

  // Stagger siblings within their groups
  [".lp-benefit-grid", ".lp-steps", ".lp-review-grid", ".lp-tiers", ".lp-accordion"].forEach(function (groupSel) {
    root.querySelectorAll(groupSel).forEach(function (group) {
      var kids = group.querySelectorAll(":scope > .lp-reveal");
      kids.forEach(function (k, i) { k.style.transitionDelay = (i * 0.08) + "s"; });
    });
  });

  // Mark ready so the hidden state + hero entrance kick in
  root.classList.add("lp-anim-ready");

  // 2) Reveal on scroll (or show all immediately if reduced/unsupported)
  if (reduce || !("IntersectionObserver" in window)) {
    root.querySelectorAll(".lp-reveal").forEach(function (el) { el.classList.add("is-visible"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    root.querySelectorAll(".lp-reveal").forEach(function (el) { io.observe(el); });
  }

  // 3) Hero chip count-up (parses leading integer, keeps suffix like "+" / " min")
  if (!reduce) {
    var chips = root.querySelectorAll(".lp-chips li strong");
    var countUp = function (el) {
      var raw = el.textContent.trim();
      var m = raw.match(/^(\d+)(.*)$/);
      if (!m) return;
      var target = parseInt(m[1], 10), suffix = m[2] || "";
      var dur = 1100, start = null;
      function tick(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    };
    // Fire shortly after load (hero is above the fold)
    setTimeout(function () { chips.forEach(countUp); }, 650);
  }

  // 4) Calculator number bump on change
  if (!reduce && "MutationObserver" in window) {
    root.querySelectorAll("#lp-drops, #lp-bottles, #lp-liters").forEach(function (el) {
      var mo = new MutationObserver(function () {
        el.classList.remove("is-bump");
        void el.offsetWidth; // force reflow to restart the animation
        el.classList.add("is-bump");
      });
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
})();
